import React, { Fragment } from 'react';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { questionsVisibility } from '../../../../../../utils/miscellaneous/pageAndQuestionsVisibility';
import { transformDropdownOptionsToObject } from '../../../../../../utils/normalize/transformDropdownOptionsToObject';

// Constants

import { DROPDOWN_OPTIONS } from '../../../../../../constants/ssap/hhmTypes/dropdownOptions';
import {HouseholdMember} from '@/components/ssap/SsapTypes';

// Types

interface GenderIdentificationSexualOrientationProps {
    genderIdentification: string | undefined;
    idx: number;
    isSogiFeatureEnabled: boolean;
    member: HouseholdMember,
    personName: string;
    sexualOrientation: string | undefined;
    serverDate: string;
}

const GenderIdentificationSexualOrientation: React.FC<GenderIdentificationSexualOrientationProps> = (props) => {
    const {
        genderIdentification,
        idx,
        isSogiFeatureEnabled,
        member: hhm,
        personName,
        serverDate,
        sexualOrientation
    } = props;

    const getGenderIdentification = (value: string | undefined): string => {
        const options = transformDropdownOptionsToObject(DROPDOWN_OPTIONS.GENDER_IDENTIFICATION);
        if (!value) {
            return options.UNSPECIFIED;
        }
        return options[value];
    };

    const getSexualOrientation = (value: string | undefined): string => {
        const options = transformDropdownOptionsToObject(DROPDOWN_OPTIONS.SEXUAL_ORIENTATION);
        if (!value) {
            return options.UNSPECIFIED;
        }
        return options[value];
    };

    const isSogiShown = questionsVisibility.isSogiShown({
        hhm,
        isSogiFeatureEnabled,
        serverDate
    });

    if(!isSogiShown) {
        return null;
    }

    return (
        <Fragment>
            <SummaryItem
                textCode = 'ssap.input.legend.gender_identification'
                replacements = { { personName } }
                value = { getGenderIdentification(genderIdentification) }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${idx}].genderIdentification`,
                            getGenderIdentification
                        ]
                    ]
                }
            />

            <SummaryItem
                textCode = 'ssap.input.legend.sexual_orientation'
                replacements = { { personName } }
                value = { getSexualOrientation(sexualOrientation) }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${idx}].sexualOrientation`,
                            getSexualOrientation
                        ]
                    ]
                }
            />
        </Fragment>
    );
};

export default GenderIdentificationSexualOrientation;